import { render, staticRenderFns } from "./PDPPricingCard.vue?vue&type=template&id=cf1f7448&scoped=true&"
import script from "./PDPPricingCard.vue?vue&type=script&lang=js&"
export * from "./PDPPricingCard.vue?vue&type=script&lang=js&"
import style0 from "./PDPPricingCard.vue?vue&type=style&index=0&id=cf1f7448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1f7448",
  null
  
)

export default component.exports